/* SUDADEROTAS · «Siempre conmigo»: más diseños de homenaje
   Huellitas en mi corazón · Navidad en el cielo · Ventana con luz · Collar y placa */
(function (root) {
"use strict";
var K = root.SDRKit;
if (!K || !K.registrar || !K.xtra || !K.A) return;
var A = K.A, X = K.xtra, sombra = X.sombra, texto = X.texto, redondo = X.redondo, f1 = K.f1;
function nombre(e) { return String(X.nombre(e) || "").replace(/​/g, "").trim(); }
function fechas(e) { return String(e.fechas || "").trim(); }
function frase(e) { return String(e.frase || "").replace(/​/g, "").trim(); }
function corazon(ctx, cx, cy, w) {
var h = w * .92; ctx.beginPath(); ctx.moveTo(cx, cy + h * .5);
ctx.bezierCurveTo(cx - w * .62, cy + h * .02, cx - w * .55, cy - h * .58, cx, cy - h * .26);
ctx.bezierCurveTo(cx + w * .55, cy - h * .58, cx + w * .62, cy + h * .02, cx, cy + h * .5); ctx.closePath();
}
function corazonSvg(x, y, s, fill, op) {
return '<path transform="translate(' + f1(x) + ' ' + f1(y) + ') scale(' + (s / 20).toFixed(3) + ')" d="M0 9 C-12 1 -11 -11 0 -5 C11 -11 12 1 0 9Z" fill="' + fill + '" opacity="' + op + '"/>';
}
function corazones(n, x0, y0, w, h, seed, fill, smin, smax) {
var r = K.rng(seed), o = "";
for (var i = 0; i < n; i++) o += corazonSvg(x0 + r() * w, y0 + r() * h, smin + r() * (smax - smin), fill, (.25 + r() * .35).toFixed(2));
return o;
}
function huellaSvg(x, y, s, fill, op, rot) {
var o = '<ellipse cx="0" cy="' + f1(s * .35) + '" rx="' + f1(s * .5) + '" ry="' + f1(s * .42) + '"/>';
[[-.5, -.25], [-.18, -.55], [.18, -.55], [.5, -.25]].forEach(function (q) { o += '<ellipse cx="' + f1(q[0] * s) + '" cy="' + f1(q[1] * s) + '" rx="' + f1(s * .17) + '" ry="' + f1(s * .22) + '"/>'; });
return '<g transform="translate(' + f1(x) + ' ' + f1(y) + ') rotate(' + (rot || 0) + ')" fill="' + fill + '" opacity="' + op + '">' + o + '</g>';
}
function huellitas(n, x0, y0, w, h, seed, fill, s) {
var r = K.rng(seed), o = "";
for (var i = 0; i < n; i++) o += huellaSvg(x0 + r() * w, y0 + r() * h, s * (.7 + r() * .6), fill, (.18 + r() * .2).toFixed(2), Math.round(r() * 60 - 30));
return o;
}
/* huellitas en canvas, rotadas en la dirección del camino */
function pisada(ctx, x, y, s, col, ang) { ctx.save(); ctx.translate(x, y); ctx.rotate(ang); K.huella(ctx, 0, 0, s, col); ctx.restore(); }
function camino(ctx, pts, s0, s1, col) {
for (var i = 0; i < pts.length; i++) {
var a = pts[Math.max(0, i - 1)], b = pts[Math.min(pts.length - 1, i + 1)], ang = Math.atan2(b[1] - a[1], b[0] - a[0]) + Math.PI / 2;
pisada(ctx, pts[i][0], pts[i][1], s0 + (s1 - s0) * i / Math.max(1, pts.length - 1), col, ang);
}
}
function gorroSanta(ctx, cx, cy, w, rot) {
ctx.save(); ctx.translate(cx, cy); ctx.rotate(rot || 0); sombra(ctx, 10, 4);
var h = w * .8, g = ctx.createLinearGradient(-w / 2, 0, w / 2, 0); g.addColorStop(0, "#b3122a"); g.addColorStop(.5, "#e3263f"); g.addColorStop(1, "#a50f25");
ctx.fillStyle = g; ctx.beginPath(); ctx.moveTo(-w * .46, 0); ctx.bezierCurveTo(-w * .4, -h * .7, w * .15, -h * 1.05, w * .62, -h * .55); ctx.bezierCurveTo(w * .3, -h * .55, w * .3, -h * .3, w * .46, 0); ctx.closePath(); ctx.fill();
ctx.shadowColor = "transparent";
ctx.fillStyle = "#ffffff"; ctx.beginPath(); ctx.arc(w * .64, -h * .52, w * .13, 0, 7); ctx.fill();
redondo(ctx, -w * .56, -h * .12, w * 1.12, h * .26, h * .13); ctx.fill();
ctx.fillStyle = "rgba(200,215,235,.6)"; redondo(ctx, -w * .56, h * .02, w * 1.12, h * .12, h * .06); ctx.fill();
ctx.restore();
}
function mangaSvg(fondo, extra) { return function () { return K.svg(600, 1400, fondo.defs || "", '<rect width="600" height="1400" fill="' + fondo.fill + '"/>' + (extra || "")); }; }
function capuchaSvg(fill, extra) { return function () { return K.svg(900, 900, "", '<rect width="900" height="900" fill="' + fill + '"/>' + (extra || "")); }; }

/* ── 1. Huellitas en mi corazón ── */
var ROSA = "#c2365e";
function arteHuellitas() {
return K.svgSangrado(K.linU("hc", [[0, "#fff6f1"], [1, "#f8d3da"]], 0, 1250),
K.fondo("url(#hc)") + corazones(60, -400, -300, 1800, 2200, 5, "#f08aa3", 10, 26) + huellitas(26, -400, -300, 1800, 2200, 6, "#c2365e", 26) + K.puntos(90, -400, -300, 1800, 2200, 7, "#ffffff", 2, 5));
}
K.registrar({
id: "huellitas", nombre: "Huellitas en mi corazón", max: 1, despuesDe: "arcoiris",
arte: { frente: arteHuellitas, espalda: arteHuellitas,
manga: mangaSvg({ fill: "url(#m)", defs: K.linU("m", [[0, "#fff6f1"], [1, "#f8d3da"]], 0, 1400) }, corazones(24, 0, 0, 600, 1400, 8, "#f08aa3", 12, 26)),
capucha: capuchaSvg("#f8d3da", corazones(20, 0, 0, 900, 900, 9, "#f08aa3", 14, 28)) },
fondo: function (ctx, w, h) { var g = ctx.createLinearGradient(0, 0, 0, h); g.addColorStop(0, "#fff6f1"); g.addColorStop(1, "#f8d3da"); ctx.fillStyle = g; ctx.fillRect(0, 0, w, h); },
resorte: function (ctx, x, y, w, h) { K.resorte(ctx, x, y, w, h, { c1: "#e8607f", c2: "#c2365e", linea: "rgba(255,255,255,.9)", paso: 40, motivo: function (c, xx, yy, u) { K.motivoCorazon(c, xx, yy, u, "#ffffff"); } }); },
dibujar: {
frente: function (ctx, e, fotos) {
texto(ctx, frase(e), 500, 175, 92, 840, ROSA, 700, "#ffffff", .22);
ctx.save(); sombra(ctx, 30, 12); var g = ctx.createLinearGradient(0, 300, 0, 900); g.addColorStop(0, "#ff8fa6"); g.addColorStop(1, "#d23a62"); ctx.fillStyle = g; corazon(ctx, 500, 610, 700); ctx.fill(); ctx.restore();
ctx.save(); ctx.fillStyle = "#fff4f6"; corazon(ctx, 500, 600, 600); ctx.fill(); ctx.restore();
camino(ctx, [[70, 1215], [150, 1150], [118, 1075], [196, 1010], [172, 936], [246, 878]], 34, 24, "rgba(194,54,94,.85)");
K.estampa(ctx, fotos[0], A.crop(e, 0), 500, 575, 400);
var n = nombre(e); if (n) texto(ctx, K.capital(n), 520, 1010, 116, 600, "#ffffff", 700, ROSA, .3);
var fe = fechas(e); if (fe) texto(ctx, fe, 520, 1110, 52, 560, ROSA, 600, "#ffffff", .2);
},
espalda: function (ctx, e) {
ctx.save(); ctx.fillStyle = "rgba(255,255,255,.75)"; corazon(ctx, 500, 560, 660); ctx.fill(); ctx.strokeStyle = "#e8607f"; ctx.lineWidth = 10; ctx.setLineDash([26, 16]); corazon(ctx, 500, 560, 610); ctx.stroke(); ctx.restore();
var n = nombre(e); texto(ctx, K.capital(n), 500, 540, 120, 470, ROSA, 700, "#ffffff", .2);
var fe = fechas(e); if (fe) texto(ctx, fe, 500, 640, 50, 440, "#7a2a44", 600);
texto(ctx, "Dejaste huellas en mi corazón", 500, 940, 56, 820, ROSA, 700, "#ffffff", .2);
camino(ctx, [[160, 1100], [250, 1060], [340, 1090], [430, 1050], [520, 1080], [610, 1040], [700, 1070], [790, 1030], [870, 1060]], 26, 26, "rgba(194,54,94,.7)");
}
}
});

/* ── 2. Navidad en el cielo ── */
function esferasSvg(lista) {
var o = "";
lista.forEach(function (q, i) {
var x = q[0], y = q[1], r = q[2], c = q[3];
o += '<line x1="' + x + '" y1="-300" x2="' + x + '" y2="' + (y - r) + '" stroke="#e9c46a" stroke-width="3" opacity=".8"/>';
o += '<rect x="' + (x - r * .22) + '" y="' + (y - r * 1.12) + '" width="' + (r * .44) + '" height="' + (r * .24) + '" rx="3" fill="#e9c46a"/>';
o += '<circle cx="' + x + '" cy="' + y + '" r="' + r + '" fill="url(#es' + i + ')"/><ellipse cx="' + f1(x - r * .38) + '" cy="' + f1(y - r * .42) + '" rx="' + f1(r * .2) + '" ry="' + f1(r * .1) + '" fill="#fff" opacity=".55" transform="rotate(-35 ' + f1(x - r * .38) + ' ' + f1(y - r * .42) + ')"/>';
});
return o;
}
var ESF = [[70, 150, 46, "#e3263f"], [205, 70, 34, "#e9c46a"], [800, 90, 36, "#4fb3a8"], [935, 190, 48, "#e3263f"], [-120, 260, 50, "#e9c46a"], [1120, 300, 52, "#4fb3a8"]];
function defsEsf() { return ESF.map(function (q, i) { return K.rad("es" + i, [[0, "#ffffff"], [.25, q[3]], [1, "#1a1030"]], .35, .3, .75); }).join(""); }
function arteCielo(conEsferas) {
return function () {
return K.svgSangrado(K.defsComunes() + defsEsf() + K.linU("cn", [[0, "#0d1640"], [.55, "#2b3b7a"], [1, "#7d6bb0"]], 0, 1250),
K.fondo("url(#cn)") + K.estrellas(80, -400, -300, 1800, 1500, 17, "#fff6c9", 3, 11) + K.puntos(150, -400, -300, 1800, 1700, 18, "#ffffff", 1, 3) +
(conEsferas ? esferasSvg(ESF) : "") +
K.nube(120, 1160, 150, "#ffffff", .9) + K.nube(880, 1170, 160, "#ffffff", .9) + K.nube(500, 1200, 250, "#ffffff", .97) + K.nube(500, 1500, 400, "#ffffff", 1));
};
}
K.registrar({
id: "cielo-navidad", nombre: "Navidad en el cielo", max: 1, despuesDe: "huellitas",
arte: { frente: arteCielo(true), espalda: arteCielo(true),
manga: mangaSvg({ fill: "url(#m)", defs: K.linU("m", [[0, "#0d1640"], [1, "#2b3b7a"]], 0, 1400) }, K.estrellas(28, 0, 0, 600, 1400, 19, "#fff6c9", 5, 12)),
capucha: capuchaSvg("#111b4a", K.estrellas(30, 0, 0, 900, 900, 20, "#fff6c9", 6, 14)) },
fondo: function (ctx, w, h) { var g = ctx.createLinearGradient(0, 0, 0, h); g.addColorStop(0, "#0d1640"); g.addColorStop(1, "#2b3b7a"); ctx.fillStyle = g; ctx.fillRect(0, 0, w, h); },
resorte: function (ctx, x, y, w, h) { K.resorte(ctx, x, y, w, h, { c1: "#b3122a", c2: "#8a0d20", linea: "rgba(255,255,255,.95)", paso: 40, motivo: function (c, xx, yy, u) { K.motivoCopo(c, xx, yy, u, "#ffffff"); } }); },
dibujar: {
frente: function (ctx, e, fotos) {
texto(ctx, frase(e), 500, 270, 88, 640, "#ffd76b", 700, "#0d1640", .22);
ctx.save(); var g = ctx.createRadialGradient(500, 650, 40, 500, 650, 380); g.addColorStop(0, "rgba(255,236,190,.6)"); g.addColorStop(1, "rgba(255,236,190,0)"); ctx.fillStyle = g; ctx.fillRect(100, 280, 800, 760); ctx.restore();
var b = K.estampa(ctx, fotos[0], A.crop(e, 0), 500, 660, 430);
if (b && b.w) gorroSanta(ctx, b.x + b.w * .5, b.y + b.h * .14, b.w * .62, .22);
var n = nombre(e); if (n) texto(ctx, K.capital(n), 500, 1010, 116, 760, "#d4a017", 700, "#ffffff", .3);
var fe = fechas(e); if (fe) texto(ctx, fe, 500, 1105, 52, 620, "#2b3b7a", 600, "#ffffff", .2);
},
espalda: function (ctx, e) {
texto(ctx, "Mi Navidad en el cielo", 500, 420, 70, 800, "#ffffff", 700, "#0d1640", .2);
var n = nombre(e); texto(ctx, K.capital(n), 500, 580, 140, 760, "#ffd76b", 700, "#0d1640", .24);
var fe = fechas(e); if (fe) texto(ctx, fe, 500, 700, 54, 600, "#ffffff", 600, "#0d1640", .18);
texto(ctx, "Siempre conmigo", 500, 1040, 60, 700, "#2b3b7a", 700, "#ffffff", .2);
}
}
});

/* ── 3. Ventana con luz ── */
function arteMuro() {
var o = "", r = K.rng(23);
for (var y = -300, i = 0; y < 1950; y += 64, i++) o += '<rect x="-400" y="' + y + '" width="1800" height="62" fill="' + ["#7a2533", "#712230", "#80293a"][i % 3] + '"/><rect x="-400" y="' + (y + 60) + '" width="1800" height="4" fill="#4a121c" opacity=".7"/>';
for (var k = 0; k < 50; k++) o += '<ellipse cx="' + f1(r() * 1800 - 400) + '" cy="' + f1(r() * 2200 - 300) + '" rx="' + f1(18 + r() * 36) + '" ry="3" fill="#4a121c" opacity=".3"/>';
return K.svgSangrado(K.defsComunes(), K.fondo("#7a2533") + o + K.puntos(140, -400, -300, 1800, 2200, 24, "#ffffff", 2, 5) +
'<path d="M-400 -300 L1400 -300 L1400 -230 Q1250 -170 1100 -225 Q900 -160 700 -220 Q500 -165 300 -222 Q100 -170 -100 -225 Q-250 -175 -400 -225Z" fill="#ffffff"/>');
}
function ventana(ctx, e, fotos) {
var x0 = 205, x1 = 795, y0 = 300, y1 = 900, w = x1 - x0, arc = w / 2;
function hueco(p) { ctx.beginPath(); ctx.moveTo(x0 + p, y1 - p); ctx.lineTo(x0 + p, y0 + arc); ctx.arc(500, y0 + arc, arc - p, Math.PI, 0); ctx.lineTo(x1 - p, y1 - p); ctx.closePath(); }
ctx.save(); sombra(ctx, 34, 14); ctx.fillStyle = "#f4ead8"; hueco(-34); ctx.fill(); ctx.restore();
ctx.save(); ctx.fillStyle = "#d9c9ad"; hueco(-10); ctx.fill(); ctx.restore();
ctx.save(); hueco(6); ctx.clip();
var g = ctx.createRadialGradient(500, 640, 30, 500, 620, 460); g.addColorStop(0, "#fff1c9"); g.addColorStop(.6, "#f6c77e"); g.addColorStop(1, "#c9783c"); ctx.fillStyle = g; ctx.fillRect(x0, y0, w, y1 - y0);
[[-1, x0], [1, x1]].forEach(function (q) {
var l = q[0], xb = q[1], gc = ctx.createLinearGradient(xb, 0, xb - l * 130, 0); gc.addColorStop(0, "#9e1b2e"); gc.addColorStop(1, "#d23a4c"); ctx.fillStyle = gc;
ctx.beginPath(); ctx.moveTo(xb, y0); ctx.lineTo(xb - l * 150, y0); ctx.bezierCurveTo(xb - l * 120, y0 + 280, xb - l * 40, y0 + 420, xb - l * 70, y1); ctx.lineTo(xb, y1); ctx.closePath(); ctx.fill();
ctx.fillStyle = "#e9c46a"; redondo(ctx, Math.min(xb, xb - l * 110) , y0 + 450, 110, 18, 9); ctx.fill();
});
K.estampa(ctx, fotos[0], A.crop(e, 0), 500, 640, 400);
[[x0, y1], [x1, y1], [500, y0]].forEach(function (c, i) { var r = i < 2 ? 170 : 220, gf = ctx.createRadialGradient(c[0], c[1], 0, c[0], c[1], r); gf.addColorStop(0, "rgba(255,255,255,.75)"); gf.addColorStop(1, "rgba(255,255,255,0)"); ctx.fillStyle = gf; ctx.fillRect(c[0] - r, c[1] - r, r * 2, r * 2); });
ctx.restore();
ctx.save(); ctx.strokeStyle = "#f4ead8"; ctx.lineWidth = 14; hueco(0); ctx.stroke(); ctx.restore();
ctx.save(); sombra(ctx, 16, 6); ctx.fillStyle = "#e8dcc4"; redondo(ctx, x0 - 70, y1 - 4, w + 140, 46, 10); ctx.fill(); ctx.restore();
ctx.save(); ctx.fillStyle = "#ffffff"; ctx.beginPath(); ctx.moveTo(x0 - 70, y1 + 2);
for (var i = 0; i <= 14; i++) { var xx = x0 - 70 + (w + 140) * i / 14; ctx.quadraticCurveTo(xx - (w + 140) / 28, y1 - 34 - (i % 2) * 12, xx, y1 + 2); }
ctx.closePath(); ctx.fill(); ctx.restore();
var vx = 700, vy = y1 - 14;
ctx.save(); var gl = ctx.createRadialGradient(vx, vy - 130, 5, vx, vy - 130, 150); gl.addColorStop(0, "rgba(255,230,150,.95)"); gl.addColorStop(1, "rgba(255,230,150,0)"); ctx.fillStyle = gl; ctx.fillRect(vx - 160, vy - 290, 320, 320); ctx.restore();
ctx.save(); sombra(ctx, 8, 3); var gv = ctx.createLinearGradient(vx - 26, 0, vx + 26, 0); gv.addColorStop(0, "#e9dcc0"); gv.addColorStop(.5, "#fffaf0"); gv.addColorStop(1, "#d9c8a8"); ctx.fillStyle = gv; redondo(ctx, vx - 26, vy - 110, 52, 110, 8); ctx.fill(); ctx.restore();
ctx.save(); ctx.fillStyle = "#ffb52e"; ctx.beginPath(); ctx.moveTo(vx, vy - 172); ctx.bezierCurveTo(vx + 22, vy - 140, vx + 16, vy - 116, vx, vy - 114); ctx.bezierCurveTo(vx - 16, vy - 116, vx - 22, vy - 140, vx, vy - 172); ctx.fill();
ctx.fillStyle = "#fff6c9"; ctx.beginPath(); ctx.ellipse(vx, vy - 130, 7, 13, 0, 0, 7); ctx.fill(); ctx.restore();
corona(ctx, 500, y0 - 40, 86);
}
function corona(ctx, cx, cy, r) {
ctx.save(); sombra(ctx, 10, 4); var rr = K.rng(31);
for (var i = 0; i < 26; i++) { var a = i / 26 * 6.283; ctx.fillStyle = ["#1f6b3a", "#2e8b4a", "#185a30"][i % 3]; ctx.beginPath(); ctx.ellipse(cx + Math.cos(a) * r, cy + Math.sin(a) * r, r * .34, r * .16, a + 1.2, 0, 7); ctx.fill(); }
ctx.shadowColor = "transparent";
for (i = 0; i < 8; i++) { var b = i / 8 * 6.283 + .2; ctx.fillStyle = "#d22630"; ctx.beginPath(); ctx.arc(cx + Math.cos(b) * r * (1 + (rr() - .5) * .2), cy + Math.sin(b) * r, r * .09, 0, 7); ctx.fill(); }
ctx.fillStyle = "#c8102e"; [-1, 1].forEach(function (l) { ctx.beginPath(); ctx.moveTo(cx, cy + r); ctx.quadraticCurveTo(cx + l * r * .7, cy + r * .55, cx + l * r * .55, cy + r * 1.25); ctx.closePath(); ctx.fill(); ctx.beginPath(); ctx.moveTo(cx, cy + r); ctx.lineTo(cx + l * r * .3, cy + r * 1.7); ctx.lineTo(cx + l * r * .12, cy + r * 1.6); ctx.closePath(); ctx.fill(); });
ctx.beginPath(); ctx.arc(cx, cy + r, r * .12, 0, 7); ctx.fill();
ctx.restore();
}
K.registrar({
id: "ventana", nombre: "Ventana con luz", max: 1, despuesDe: "cielo-navidad",
arte: { frente: arteMuro, espalda: arteMuro,
manga: mangaSvg({ fill: "#7a2533" }, K.puntos(60, 0, 0, 600, 1400, 25, "#ffffff", 2, 5)),
capucha: capuchaSvg("#712230", K.puntos(40, 0, 0, 900, 900, 26, "#ffffff", 2, 5)) },
fondo: function (ctx, w, h) { ctx.fillStyle = "#7a2533"; ctx.fillRect(0, 0, w, h); },
resorte: function (ctx, x, y, w, h) { K.resorte(ctx, x, y, w, h, { c1: "#1f6b3a", c2: "#14502b", linea: "rgba(233,196,106,.9)", paso: 40, motivo: function (c, xx, yy, u) { K.motivoCopo(c, xx, yy, u, "#ffffff"); } }); },
dibujar: {
frente: function (ctx, e, fotos) {
texto(ctx, frase(e), 500, 120, 84, 860, "#ffffff", 700, "#4a121c", .22);
ventana(ctx, e, fotos);
var n = nombre(e), fe = fechas(e);
if (n || fe) { ctx.save(); sombra(ctx, 14, 6); var g = ctx.createLinearGradient(0, 960, 0, 1140); g.addColorStop(0, "#a8743f"); g.addColorStop(1, "#7a4f28"); ctx.fillStyle = g; redondo(ctx, 230, 975, 540, fe ? 170 : 130, 22); ctx.fill(); ctx.restore();
ctx.save(); ctx.strokeStyle = "#e9c46a"; ctx.lineWidth = 5; redondo(ctx, 244, 989, 512, (fe ? 170 : 130) - 28, 16); ctx.stroke(); ctx.restore(); }
if (n) texto(ctx, K.capital(n), 500, 1038, 88, 470, "#fff1c9", 700, "#4a2c16", .18);
if (fe) texto(ctx, fe, 500, 1106, 42, 460, "#fff1c9", 600);
},
espalda: function (ctx, e) {
corona(ctx, 500, 520, 250);
var n = nombre(e); texto(ctx, K.capital(n), 500, 520, 104, 380, "#ffffff", 700, "#4a121c", .24);
var fe = fechas(e); if (fe) texto(ctx, fe, 500, 615, 44, 360, "#fff1c9", 600, "#4a121c", .18);
texto(ctx, "Siempre en casa", 500, 1010, 76, 800, "#fff1c9", 700, "#4a121c", .22);
}
}
});

/* ── 4. Collar y placa ── */
var CAFE = "#5a3a28";
function artePlaca() {
return K.svgSangrado(K.linU("pl", [[0, "#f7f1e6"], [1, "#e9dfcc"]], 0, 1250),
K.fondo("url(#pl)") + huellitas(34, -400, -300, 1800, 2200, 41, "#8a6a4f", 30) + K.puntos(80, -400, -300, 1800, 2200, 42, "#c9b48f", 2, 4));
}
function placaHueso(ctx, cx, cy, w, h) {
/* hueso: barra + cuatro bolitas */
var r = h * .3, bar = h * .44;
ctx.beginPath();
ctx.rect(cx - w / 2 + r, cy - bar / 2, w - 2 * r, bar);
[[-1, -1], [-1, 1], [1, -1], [1, 1]].forEach(function (q) { ctx.moveTo(cx + q[0] * (w / 2 - r) + r, cy + q[1] * r * .78); ctx.arc(cx + q[0] * (w / 2 - r), cy + q[1] * r * .78, r, 0, 7); });
}
function collar(ctx, e, fotos) {
ctx.save(); sombra(ctx, 16, 8); ctx.lineCap = "round";
ctx.strokeStyle = "#8f1f2e"; ctx.lineWidth = 64; ctx.beginPath(); ctx.moveTo(150, 770); ctx.quadraticCurveTo(500, 990, 850, 770); ctx.stroke(); ctx.restore();
ctx.save(); ctx.lineCap = "round"; ctx.strokeStyle = "#b8283c"; ctx.lineWidth = 50; ctx.beginPath(); ctx.moveTo(150, 770); ctx.quadraticCurveTo(500, 990, 850, 770); ctx.stroke();
ctx.strokeStyle = "rgba(255,230,200,.85)"; ctx.lineWidth = 3; ctx.setLineDash([12, 10]);
[-15, 15].forEach(function (d) { ctx.beginPath(); ctx.moveTo(150, 770 + d); ctx.quadraticCurveTo(500, 990 + d, 850, 770 + d); ctx.stroke(); });
ctx.restore();
ctx.save(); var gb = ctx.createLinearGradient(250, 0, 330, 0); gb.addColorStop(0, "#c98a16"); gb.addColorStop(.5, "#fff1b8"); gb.addColorStop(1, "#c98a16"); ctx.strokeStyle = gb; ctx.lineWidth = 12; redondo(ctx, 262, 795, 66, 80, 14); ctx.stroke(); ctx.fillStyle = "#c98a16"; ctx.fillRect(292, 800, 8, 72); ctx.restore();
ctx.save(); ctx.strokeStyle = "#d9a826"; ctx.lineWidth = 10; ctx.beginPath(); ctx.arc(500, 902, 26, 0, 7); ctx.stroke(); ctx.restore();
var n = nombre(e), fe = fechas(e), cy = 1040;
ctx.save(); sombra(ctx, 18, 8); var g = ctx.createLinearGradient(0, cy - 90, 0, cy + 90); g.addColorStop(0, "#fff1b8"); g.addColorStop(.45, "#f2c14e"); g.addColorStop(1, "#b97f12"); ctx.fillStyle = g; placaHueso(ctx, 500, cy, 500, 190); ctx.fill(); ctx.restore();
ctx.save(); ctx.strokeStyle = "#d9a826"; ctx.lineWidth = 8; ctx.beginPath(); ctx.moveTo(500, 928); ctx.lineTo(500, cy - 52); ctx.stroke(); ctx.restore();
if (n) texto(ctx, K.capital(n), 500, fe ? cy - 14 : cy, 72, 300, "#6b4410", 700);
if (fe) texto(ctx, fe, 500, cy + 40, 32, 290, "#6b4410", 600);
}
K.registrar({
id: "placa", nombre: "Collar y placa", max: 1, despuesDe: "ventana",
arte: { frente: artePlaca, espalda: artePlaca,
manga: mangaSvg({ fill: "#efe6d6" }, huellitas(10, 0, 0, 600, 1400, 43, "#8a6a4f", 30)),
capucha: capuchaSvg("#e9dfcc", huellitas(8, 0, 0, 900, 900, 44, "#8a6a4f", 30)) },
fondo: function (ctx, w, h) { ctx.fillStyle = "#efe6d6"; ctx.fillRect(0, 0, w, h); },
resorte: function (ctx, x, y, w, h) { K.resorte(ctx, x, y, w, h, { c1: "#b8283c", c2: "#8f1f2e", linea: "rgba(255,230,200,.9)", paso: 40, motivo: function (c, xx, yy, u) { K.motivoCorazon(c, xx, yy, u, "#f2c14e"); } }); },
dibujar: {
frente: function (ctx, e, fotos) {
texto(ctx, frase(e), 500, 170, 88, 840, CAFE, 700, "#ffffff", .2);
K.estampa(ctx, fotos[0], A.crop(e, 0), 500, 545, 440);
collar(ctx, e, fotos);
},
espalda: function (ctx, e) {
var n = nombre(e), fe = fechas(e), cy = 560;
ctx.save(); sombra(ctx, 20, 8); var g = ctx.createLinearGradient(0, cy - 150, 0, cy + 150); g.addColorStop(0, "#fff1b8"); g.addColorStop(.45, "#f2c14e"); g.addColorStop(1, "#b97f12"); ctx.fillStyle = g; placaHueso(ctx, 500, cy, 820, 310); ctx.fill(); ctx.restore();
if (n) texto(ctx, K.capital(n), 500, fe ? cy - 24 : cy, 120, 520, "#6b4410", 700);
if (fe) texto(ctx, fe, 500, cy + 64, 50, 500, "#6b4410", 600);
texto(ctx, "Para siempre en mi corazón", 500, 960, 58, 820, CAFE, 700, "#ffffff", .18);
}
}
});

X.marcar("huellitas", "memorial", ["EN MI CORAZÓN", "DEJASTE HUELLA", "SIEMPRE CONMIGO", "TE EXTRAÑO", "GRACIAS POR TODO"]);
X.marcar("cielo-navidad", "memorial", ["NAVIDAD EN EL CIELO", "MI ANGELITO", "SIEMPRE CONMIGO", "TE EXTRAÑO", "FELIZ NAVIDAD"]);
X.marcar("ventana", "memorial", ["SIEMPRE EN CASA", "AQUÍ TE ESPERO", "SIEMPRE CONMIGO", "TE EXTRAÑO", "GRACIAS POR TODO"]);
X.marcar("placa", "memorial", ["PARA SIEMPRE MÍO", "PARA SIEMPRE MÍA", "SIEMPRE CONMIGO", "MI MEJOR AMIGO", "GRACIAS POR TODO"]);
})(this);
